import { StyleSheet } from 'react-native-unistyles';

export const styles = StyleSheet.create(() => ({
  trigger: {
    alignItems: 'center',
    justifyContent: 'center',
  },
}));
